import { Flow } from "@/interfaces/sdk-flow";

export const extractUrlParams = async (url: string) => {
  const formUrl = new URL(url);
  const entries = formUrl.searchParams.entries();
  const urlParams: Flow.Task.Form.UrlParams = {};

  for await (const pair of entries) {
    const [key, value] = pair;
    urlParams[key] = value;
  }

  return urlParams;
};

export const mountUrlParams = async (requiredParams: Flow.Task.Form.ScreenParameters[]): Promise<Flow.Task.Form.UrlParams> => {
  const mapRequiredParams: Flow.Task.Form.UrlParams = {};

  for await (const param of requiredParams) {
    mapRequiredParams[param.parameter] = "";
  }

  return mapRequiredParams;
};

export const generateUrl = (url: string, urlParams: Flow.Task.Form.UrlParams) => {
  const newFormUrl = new URL(url);
  Object.entries(urlParams).map(([key, value]) => {
    newFormUrl.searchParams.set(key, value);
  });
  return newFormUrl.href;
};
